







































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { ModelSync, Prop } from 'vue-property-decorator'
import { isDef } from '@/modules/shared/helpers/utils/utils'
import { TableTabsModel } from '@/modules/common/tes-table/models/table-tabs.model'

@Component
export default class TableTabs extends Vue {
  @ModelSync('value', 'input') tab!: string

  @Prop() tabs!: TableTabsModel[]

  get labelClasses() {
    if (this.$q.screen.lt.md) {
      return 'font-size-12'
    } else {
      return 'q-mx-sm font-size-14'
    }
  }

  detailVisibility(value): boolean {
    return this.$q.screen.gt.sm && isDef(value)
  }
}
